import SYSTEM_CONSTANTS from '../common/constants';
import {AttributeData, Icon, IconAttributes, ResponseData } from '../common/define-types';
import HttpClient from './http-client';
import {AjaxError} from 'rxjs/ajax';
import {Observable, throwError} from 'rxjs';
import {catchError, map} from 'rxjs/operators';

export interface Video {
  Description: string;
  createdAt: string;
  updatedAt: string;
  publishedAt: string;
  Title: string;
  id?: number;
  Video?: {
    data: IconAttributes;
  }
}

export interface Child {
  createdAt: string;
  updatedAt: string;
  publishedAt: string;
  Name: string;
  Age: string;
  id: number;
  Address: string;
  Status: string;
  Description: string;
  Ngay_den: string;
  Birthday: string;
  Avatar?: {
    data: IconAttributes;
  };
  videos: {
    data: AttributeData<Video>[];
  },
  Images:{
    data?: IconAttributes[]
  }
}

export default class ChildsAPI {
  static host = SYSTEM_CONSTANTS.HOST;
  static get(): Observable<ResponseData<Child> | null> {
      let api = `${ChildsAPI.host}/${SYSTEM_CONSTANTS.Child.GET}?populate=Avatar,videos`;
      return HttpClient.get(api, {
          headers: {
              'Content-Type': 'application/json; charset=utf-8',
          },
      }).pipe(
          map(
              res => (res as ResponseData<Child>) || null,
              catchError((e: AjaxError) => throwError(e)),
          ),
      );
  }
  static getChild(id: number): Observable<ResponseData<Child> | null> {
    let api = `${ChildsAPI.host}/${SYSTEM_CONSTANTS.Child.GET}?populate=Avatar,videos,Images&filters[id][$eq]=${id}&populate=videos.Video`;
    return HttpClient.get(api, {
        headers: {
            'Content-Type': 'application/json; charset=utf-8',
        },
    }).pipe(
        map(
            res => (res as ResponseData<Child>) || null,
            catchError((e: AjaxError) => throwError(e)),
        ),
    );
}
}
